import { render, staticRenderFns } from "./GemsPlansPage.vue?vue&type=template&id=61649e01&"
import script from "./GemsPlansPage.vue?vue&type=script&lang=js&"
export * from "./GemsPlansPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports